"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
export const useResizeObserver = (element, callback) => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] !== callback || $[1] !== element) {
    t0 = () => {
      if (element) {
        const resizeObserver = new ResizeObserver(callback);
        resizeObserver.observe(element);
        return () => {
          resizeObserver.disconnect();
        };
      }
    };
    t1 = [element, callback];
    $[0] = callback;
    $[1] = element;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
};